<template>
  <div class="form-list">
    <el-form
      ref="form"
      :model="card"
      label-position="right"
      label-width="130px"
      class="form"
    >

      <el-form-item label="所属学员">
        <v-avatar-nickname
          :value="card.selfie"
          :nickname="card.student_name"
          :is-center="false"
          :link-page-name="RouteConfig.studentDetail.name"
          :link-page-id="card.student_id"
        />
      </el-form-item>

      <el-form-item label="课卡名称">{{ card.card_name }}</el-form-item>
      <el-form-item label="有效次数" v-show="card.is_number_limit">{{ card.expire_number }}</el-form-item>
      <el-form-item label="有效天数">{{ card.expire_days }}</el-form-item>
      <el-form-item label="办卡日期">{{ card.register_time | timeToYmd }}</el-form-item>
      <el-form-item label="失效日期">{{ card.expire_time | timeToYmd }}</el-form-item>
      <el-form-item label="实际付款">{{ card.actual_payment }}</el-form-item>

      <!-- 停卡中：退卡审批会被状态守卫拦截，故展示页直接禁用提交 -->
      <el-alert
        v-if="card.is_stopped"
        type="warning"
        show-icon
        :closable="false"
        title="该课卡停卡中：需超管提前开卡后才能退卡（提前开卡会把已停时长顺延至有效期）"
      />

      <!-- 课次券提示：课卡已绑定课次券时，退卡前需告知用户券将自动失效 -->
      <v-card-ticket-warning
        v-if="cardTickets.length"
        :tickets="cardTickets"
        message="该课卡已绑定以下课次券，退卡后这些课次券将自动失效，请确认后再提交。"
      />

      <el-form-item label="退款金额" prop="del_payment">
        <v-input-money
          class="w100"
          v-model="card.del_payment"
          :is-show-suffix="true"
          placeholder="请输入给学员退卡的所付的金额"
        />
      </el-form-item>

      <el-form-item label="退卡原因">
        <el-radio v-model="card.is_input_error" :label="0">非录入错误</el-radio>
        <el-radio v-model="card.is_input_error" :label="1">录入错误</el-radio>
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入 2 个字符以上的退卡原因"
          v-model="card.del_remark"
          maxlength="250"
          show-word-limit
        />
      </el-form-item>

      <v-image-upload
        v-model="card.del_cover"
        label="退卡原因截图"
        prefix="card"
        ratio="9:20"
      />

      <el-form-item>
        <router-link v-if="card.card_del_apply_id" class="button-margin" :to="RouteConfig.cardDeleteApplyDetail.to(card.card_del_apply_id)">
          <el-button type="primary">退卡申请审核中，点击查看</el-button>
        </router-link>
        <router-link v-else-if="card.card_update_apply_id" class="button-margin" :to="RouteConfig.cardUpdateApplyDetail.to(card.card_update_apply_id)">
          <el-button type="primary">课卡修改审核中，点击查看</el-button>
        </router-link>
        <el-button v-else-if="card.is_reviewing" class="button-margin" :disabled="true" type="primary">修改申请审核中</el-button>
        <el-button v-else-if="card.is_stopped" class="button-margin" :disabled="true" type="danger">停卡中，请先提前开卡再退卡</el-button>
        <el-button v-else class="button-margin" :loading="isSaving" @click="handleSubmit" type="danger">
          {{ isAdministrator ? '' : '申请' }}退卡
        </el-button>
        <el-button @click="RouteConfig.cardList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { destroy, show } from '@/api/card';
import { store } from '@/api/card-del-apply';
import { toYuan, toCent, toMillisecond } from '@/filters';

export default {
  name: RouteConfig.cardDelete.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    cardTickets: [],
    card: {
      is_input_error: 0,
      is_reviewing: 0,
      is_stopped: 0,
      card_del_apply_id: 0,
      card_update_apply_id: 0,
      student_id: 0,
      selfie: '',
      student_name: '',
      card_name: '',
      expire_number: '',
      expire_days: '',
      register_time: '',
      expire_time: '',
      actual_payment: '',

      del_cover: '',
      del_payment: 0,
      del_remark: '',
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  watch: {
    'card.is_input_error'(value) {
      let { card } = this;
      if (value) {
        if (!card.del_remark) card.del_remark = '录入错误';
      } else {
        if (card.del_remark === '录入错误') card.del_remark = '';
      }
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      this.cardTickets = data.card_tickets || [];

      if (data.store_limit_expire_time) data.store_limit_expire_time = toMillisecond(data.store_limit_expire_time);
      if (data.expire_number) data.expire_number = toYuan(data.expire_number);
      if (data.actual_payment) {
        data.actual_payment = toYuan(data.actual_payment);
        data.del_payment = data.actual_payment;
      }

      const { card } = this;
      const updateCardInfo = {};
      Object.keys(data).forEach(key => {
        if (key in card) updateCardInfo[key] = data[key];
      });
      Object.assign(card, updateCardInfo);
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.card };
        postData.del_payment = toCent(postData.del_payment);
        postData.card_id = this.id;

        const { isError } = this.isAdministrator
          ? await destroy(this.id, postData)
          : await store(postData);

        this.isSaving = false;
        if (isError) return;

        this.isAdministrator ? RouteConfig.cardDeletedList.push() : RouteConfig.cardDeleteApplyList.push();
      });
    },
  },
};
</script>
